import React, { createContext, useContext, useRef, ReactNode, RefObject, useState } from 'react';

interface RefContextType {
  footerRef: HTMLElement;
  setFooterRef: (element: HTMLElement | null) => void;
}

const RefContext = createContext<RefContextType | undefined>(undefined);

interface RefProviderProps {
  children: ReactNode;
}

export const RefProvider: React.FC<RefProviderProps> = ({ children }) => {
  const [footerRef, setFooterRef] = useState<HTMLElement | null>(null);

  return (
    <RefContext.Provider value={{ footerRef, setFooterRef }}>
      {children}
    </RefContext.Provider>
  );
};

export const useRefContext = () => {
  const context = useContext(RefContext);
  return context || { footerRef: null, setFooterRef: () => {} };
};